import styled from 'styled-components';
import ToggleButton from '@material-ui/lab/ToggleButton';
import { Button } from '@material-ui/core';
export const CardWrapper = styled.div`
  width: inherit;
  display: flex;
  flex-direction: ${props => props.recommendationTab ? 'column' : 'row'};
  height: 100%;
`;
export const StyledRiskScoreContainer = styled.div`
  display: flex;
  margin-left: ${props => props.recommendationTab ? '24px' : '0'};
  margin-bottom: ${props => props.recommendationTab ? '24px' : '0'};
  margin-top: ${props => props.recommendationTab ? '24px' : '0'};
`;
export const ChartCardShadow = styled.div`
  width: 250px;
  padding: 0 16px 16px 16px;
  border-radius: 5px;
  background: white;
  position: relative;
  margin-right: ${props => props.recommendationTab ? '24px' : '10px'};
  border: ${props => props.recommendationTab ? '1px solid #c6c6c6' : 'none'};
`;
export const ResourceDistributionCard = styled.div`
  width: 100%;
  padding: 0 16px 16px 16px;
  border-radius: 5px;
  background: white;
  position: relative;
  margin-right: 24px;
  border: ${props => props.recommendationTab ? '1px solid #c6c6c6' : 'none'};
`;
export const LineCardShadow = styled.div`
  width: ${props => props.recommendationTab ? 'auto' : '100%'};
  margin-left: ${props => props.recommendationTab ? '24px' : '0'};
  margin-right: ${props => props.recommendationTab ? '24px' : '0'};
  margin-bottom: ${props => props.recommendationTab ? '32px' : '0'};
  padding: 0 16px;
  border-radius: 5px;
  background: white;
  border: ${props => props.recommendationTab ? '1px solid #c6c6c6' : 'none'};
  canvas {
    width: 100% !important;
    height: 150px !important;
  }
`;
export const ChartTitle = styled.div`
  margin: 0;
  padding: 16px 8px;
  font-family: 'OpenSans-Regular';
  font-size: 17px;
  color: black;
  opacity: 0.9;
`;
export const ButtonStyleWrapper = styled(ToggleButton)`
  &.MuiToggleButton-root:focus {
    color: black !important;
    background-color: #c2d7e4 !important;
    margin: 0px 8px 0px 0px;
    border-radius: 5px;
    text-transform: none;
    height: 32px !important;
    min-width: 72px !important;
    border-color: #223390 !important;
    border-radius: 5px !important;
    font-family: 'OpenSans-Regular';
    line-height: 14px !important;
    outline: none !important;
    border: 1px solid rgba(0, 0, 0, 0.12);
    padding: 11px;
    font-size: 13px;
    box-sizing: border-box;
  }
`;
export const StyledDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
export const StyledButton = styled(Button)`
  && {
    background: ${props => props.isSelected ? 'rgba(166, 194, 255, 0.19) !important' : '#fff'};
    border: ${props => props.isSelected ? '1px solid #002d8e' : '#fff'};
    border-radius: ${props => props.isSelected ? ' 4px !important' : '0px'};
    align-items: center;
    border-radius: 4px !important;
    margin: 0px 4px 0px 4px;
    height: 28px;
    font-size: 12px;
    line-height: 28px;
    color: #3d3f40;
    font-family: 'OpenSans-Regular';
    font-weight: 500;
    border-radius: 0px !important;
    width: 55px !important;
    padding: 6px 11px;
    box-sizing: border-box;
    line-height: 20px !important;
    border-color: #002d8e !important;
    border-radius: 4px !important;
  }
`;
export const RiskChartTitle = styled.div`
  margin: 0;
  padding: 16px 8px;
  font-family: 'OpenSans-Regular';
  font-size: 17px;
  color: black;
  opacity: 0.9;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  width: 20%;
`;
export default {
  CardWrapper,
  ChartCardShadow,
  LineCardShadow,
  ChartTitle,
  ButtonStyleWrapper,
  StyledDiv,
  RiskChartTitle,
  StyledButton
};